import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Table, { buttonsStyle, dateFormatter } from "../tables/table";

function getData(cabeceras, partidas, capitulos, partidasCategorias) {
  let data = [];

  for (let i = 0; i < partidas.length; ++i) {
    const elem = {};
    const partida = partidas[i];

    elem.referencia = partida?.referencia;
    elem.descripcion = partida?.descripcion;
    elem.categoria = partidasCategorias.find(
      (x) => x.id === partida?.categoria_id
    )?.descripcion;
    elem.revision_num = partida?.revision_num;
    const capitulo = capitulos.find(
      (x) =>
        x.capitulo_id === partida.capitulo_id &&
        x.revision_num === partida.revision_num
    );
    elem.capitulo = partidasCategorias.find(
      (x) => x.id === capitulo?.partida_categoria_id
    )?.descripcion;
    elem.fecha = dateFormatter(
      cabeceras.find(
        (x) =>
          x.id === partida.oferta_id && x.revision_num === partida.revision_num
      )?.fecha_alta
    );
    elem.obj = partida;

    data = data.concat(elem);
  }

  return data;
}

const PartidaRevisionTableDialog = (props) => {
  const {
    title,
    open,
    setOpen,
    cabeceras,
    partidas,
    capitulos,
    partidasCategorias,
    onSelect,
  } = props;

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function buttonFormatter(cell) {
    return (
      <>
        <Tooltip title="Seleccionar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={(e) => {
              onSelect(cell);
              setOpen(false);
            }}
          >
            <AddCircle />
          </Button>
        </Tooltip>
      </>
    );
  }

  const columns = [
    { dataField: "referencia", text: "Referencia", sort: true },
    {
      dataField: "descripcion",
      text: "Descripción",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "categoria",
      text: "Categoría",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "capitulo",
      text: "Capítulo",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "revision_num",
      text: "Numero de revisión",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "fecha",
      text: "Fecha",
      sort: true,
      headerAlign: "center",
      align: "center",
    },
    { dataField: "obj", text: "", formatter: buttonFormatter },
  ];

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="xl"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">
          <div className="d-flex justify-content-between">{"Partidas"}</div>
        </DialogTitle>
        <DialogContent>
          {!partidas || !partidas.length ? (
            <p>{"No hay partidas disponibles."}</p>
          ) : (
            <Table
              data={getData(cabeceras, partidas, capitulos, partidasCategorias)}
              columns={columns}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            className="mr-2"
            onClick={() => {
              setOpen(false);
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
    </>
  );
};
export default PartidaRevisionTableDialog;
